var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactMovil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 610.11 710.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-21);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-16 {\n        stroke: url(#linear-gradient-13);\n      }\n\n      .cls-16, .cls-17, .cls-18, .cls-19, .cls-20 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-16, .cls-17, .cls-18, .cls-20 {\n        fill: none;\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-17 {\n        stroke: url(#linear-gradient-12);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-20);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-18 {\n        stroke: url(#linear-gradient-4);\n        stroke-width: 2.11px;\n      }\n\n      .cls-18, .cls-20 {\n        stroke-linecap: round;\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient);\n        stroke: url(#linear-gradient-2);\n        stroke-width: 1.13px;\n      }\n\n      .cls-19, .cls-14 {\n        opacity: .19;\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-20 {\n        stroke: url(#linear-gradient-3);\n        stroke-width: 3.22px;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 97.65,
    y1: 711,
    x2: 507.57,
    y2: 0.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7427e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#e53d75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#df315e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#d71d38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d5182e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 97.25,
    y1: 711.5,
    x2: 507.8,
    y2: 0.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 96.52,
    y1: 712.41,
    x2: 508.23,
    y2: -0.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 118.61,
    y1: 676.14,
    x2: 486.83,
    y2: 38.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 119.17,
    y1: 675.16,
    x2: 486.26,
    y2: 39.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 455.37,
    y1: 4.2,
    x2: 457.63,
    y2: 0.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 444.5,
    y1: 4.2,
    x2: 446.75,
    y2: 0.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 432.5,
    y1: 4.2,
    x2: 434.75,
    y2: 0.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -83.45,
    y1: 636.94,
    x2: 259.52,
    y2: 42.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 505.23,
    y1: 174.34,
    x2: 595.55,
    y2: 17.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 425.19,
    y1: 765.35,
    x2: 610,
    y2: 445.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 272.56,
    y1: 46.13,
    x2: 320.63,
    y2: -37.13,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 205.36,
    y1: 748.16,
    x2: 248.96,
    y2: 672.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 604.21,
    y1: 264.11,
    x2: 613.2,
    y2: 248.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 604.21,
    y1: 287.86,
    x2: 613.2,
    y2: 272.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 604.21,
    y1: 311.61,
    x2: 613.2,
    y2: 296.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 604.21,
    y1: 335.36,
    x2: 613.2,
    y2: 319.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 604.21,
    y1: 359.11,
    x2: 613.2,
    y2: 343.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 604.21,
    y1: 382.86,
    x2: 613.2,
    y2: 367.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 604.21,
    y1: 406.61,
    x2: 613.2,
    y2: 391.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 604.21,
    y1: 430.36,
    x2: 613.2,
    y2: 414.78,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M31.66,80.4l44.22-56.91h470.65c16.11,20.73,25.14,32.36,41.25,53.09v557.36l-41.25,53.09H56.14c-15.64-20.13-24.41-31.41-40.05-51.54V80.36l15.57.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M56.14,687.03h490.4l41.25-53.09V76.58c-16.11-20.73-25.14-32.36-41.25-53.09H75.88l-44.22,56.91-15.57-.05v555.14c15.64,20.13,24.41,31.41,40.05,51.54Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M515.06,658.53H90.38c-11.97-11.97-18.67-18.67-30.64-30.64V86.6c11.97-11.97,18.67-18.67,30.64-30.64h424.67c11.97,11.97,18.67,18.67,30.64,30.64v541.3l-30.64,30.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M515.06,658.53H90.38c-11.97-11.97-18.67-18.67-30.64-30.64V86.6c11.97-11.97,18.67-18.67,30.64-30.64h424.67c11.97,11.97,18.67,18.67,30.64,30.64v541.3l-30.64,30.64Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 456.5,
    cy: 2.25,
    r: 2.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 445.63,
    cy: 2.25,
    r: 2.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 433.63,
    cy: 2.25,
    r: 2.25
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "132.33 707.38 45.07 707.38 3.01 663.67 2.95 50.9 16.09 51.03 60.28 4.03 185.54 4.03 186.99 1.02 59 1.02 14.99 48.21 0 48.21 0 664.89 43.79 710.39 129.79 710.39 132.33 707.38"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "607.1 47.74 607.1 233.16 610.11 230.14 610.11 46.53 566.32 1.02 468.2 1.02 467.09 4.03 565.04 4.03 607.1 47.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "607.1 447.28 607.1 663.67 565.04 707.38 332.51 707.38 330 710.39 566.32 710.39 610.11 664.89 610.11 445.32 607.1 447.28"
  }))), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 201.32,
    y1: 4.5,
    x2: 391.88,
    y2: 4.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 140.82,
    y1: 710.39,
    x2: 313.5,
    y2: 710.39
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "607.3 249.59 607.3 265.89 610.11 263.05 610.11 246.75 607.3 249.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "607.3 273.34 607.3 289.64 610.11 286.8 610.11 270.5 607.3 273.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "607.3 297.09 607.3 313.39 610.11 310.55 610.11 294.25 607.3 297.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "607.3 320.84 607.3 337.14 610.11 334.3 610.11 318 607.3 320.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "607.3 344.59 607.3 360.89 610.11 358.05 610.11 341.75 607.3 344.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "607.3 368.34 607.3 384.64 610.11 381.8 610.11 365.5 607.3 368.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "607.3 392.09 607.3 408.39 610.11 405.55 610.11 389.25 607.3 392.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "607.3 415.84 607.3 432.14 610.11 429.3 610.11 413 607.3 415.84"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactMovil);
export default __webpack_public_path__ + "static/media/contactMovil.a4119337b63cdb0604945f36984d1f96.svg";
export { ForwardRef as ReactComponent };